navApp.factory('NavDataService', [
  '$q', '$http', '_', 'endpointDomain', function($q, $http, _, endpointDomain) {
    return {
      getNavForBranch: _.memoize(function(branch) {
        return this.getFrom(endpointDomain + "?eID=qscnav/navdata/basic&branch=" + branch);
      }),
      getPrimaryNav: _.memoize(function() {
        return this.getFrom(endpointDomain + "?eID=qscnav/navdata/primary&branch=1");
      }),
      getFrom: function(uri) {
        var deferred;
        deferred = $q.defer();
        $http.get(uri).success(function(data) {
          return deferred.resolve(data);
        });
        return deferred.promise;
      }
    };
  }
]);
